import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class PropertySuggestionsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('propertySuggestionsError', ...args);
    }
}
export default PropertySuggestionsError;
